// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ZQgj","content":"RecentSearches_content__2E-RF"};